module.exports = __webpack_public_path__ + "images/emoji/arrow_backward.109a06201d7bfb734c7d.png";